/**
 * 全局事件总线
 */

import Vue from 'vue';

export const eventBus = new Vue();

export default eventBus;
